'use client';

type AuthCaptchaFieldProps = {
  containerId: string;
  provider?: string | null;
  show: boolean;
  protectedLabel: string;
};

const isInvisibleProvider = (provider?: string | null): boolean =>
  provider === 'google_recaptcha_v3' || provider === 'google_recaptcha_enterprise';

/**
 * v2 / Turnstile: widget container.
 * Enterprise / v3: görünür "korumalı" metni (görünmez skor tabanlı doğrulama).
 */
export default function AuthCaptchaField({
  containerId,
  provider,
  show,
  protectedLabel,
}: AuthCaptchaFieldProps) {
  if (!show) {
    return null;
  }

  if (isInvisibleProvider(provider)) {
    return (
      <div className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 text-center">
        <p className="text-xs text-gray-600 leading-relaxed">{protectedLabel}</p>
        {/* Script init / cleanup için sabit id (görünmez provider) */}
        <div id={containerId} className="hidden" aria-hidden />
      </div>
    );
  }

  return <div id={containerId} className="flex min-h-[78px] justify-center" />;
}
